// Messages for operator/companies/ImpersonateModal (auto-merged by lib/i18n.ts).
export const en = {
  'operator.impersonate.title': 'Impersonate — {name}',
  'operator.impersonate.cancel': 'Cancel',
  'operator.impersonate.start': 'Start session',
  'operator.impersonate.blurb_before': "You'll open the portal ",
  'operator.impersonate.blurb_bold': 'as this user sees it',
  'operator.impersonate.blurb_after':
    ' — their data only, never internal cost or other customers. The session is time-boxed, shows a banner, and start & stop are audited.',
  'operator.impersonate.none': '{name} has no portal users to impersonate yet.',
  'operator.impersonate.view_as': 'View as portal user',
  'operator.impersonate.portal_user_aria': 'Portal user',
  'operator.impersonate.reason': 'Reason (required)',
  'operator.impersonate.reason_aria': 'Reason',
  'operator.impersonate.reason_placeholder':
    'e.g. Reproducing the tracking discrepancy from ticket #4821',
}

export const zhTW = {
  'operator.impersonate.title': '模擬登入 — {name}',
  'operator.impersonate.cancel': '取消',
  'operator.impersonate.start': '開始工作階段',
  'operator.impersonate.blurb_before': '您將以',
  'operator.impersonate.blurb_bold': '此使用者所見的方式',
  'operator.impersonate.blurb_after':
    '開啟入口 — 僅限其資料，絕不顯示內部成本或其他客戶。工作階段有時間限制、會顯示橫幅，且開始與結束皆會記錄稽核。',
  'operator.impersonate.none': '{name}尚無可模擬登入的入口使用者。',
  'operator.impersonate.view_as': '以入口使用者身分檢視',
  'operator.impersonate.portal_user_aria': '入口使用者',
  'operator.impersonate.reason': '原因（必填）',
  'operator.impersonate.reason_aria': '原因',
  'operator.impersonate.reason_placeholder': '例如：重現工單 #4821 中的追蹤差異',
}
